export default {
  title: 'Espace partenaire',
  titlePrefix: 'à l\'',
  ErrorTitle: 'Erreur technique',
  ErrorMessage: 'Nous sommes désolés des inconvénients que cela peut vous causer.',
  ErrorRetryButton: 'Réessayer',
  NotFoundTitle: 'Page introuvable',
  NotFoundMessage: 'Désolé, la page a été déplacée ou supprimée.',
  NotFoundBackButton: 'Retour',
  copyright: `© ${new Date().getFullYear()} iA Groupe financier est une marque de commerce et un autre nom sous lequel l’Industrielle Alliance, Assurance et services financiers inc. exerce ses activités.`,
};
